"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesSelectorTable = PropertiesSelectorTable;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const contexts_1 = require("@genesys/client-core/lib/contexts");
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const row_selector_1 = require("./row-selector");
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
function PropertiesSelectorTable(props) {
    return (React.createElement(contexts_1.TranslateContext.Consumer, null, translate => {
        const propertyHeaders = createPropertyDefinitions(props.pressure, uom_1.Amount.create(0, uom_1.Units.Celsius), props.showPower).map(property => (React.createElement("th", { key: property.name }, translate(LanguageTexts.globalPropertyName(property.name)))));
        return (React.createElement(Elements.StyledTable, null,
            React.createElement("thead", null,
                React.createElement("tr", null, propertyHeaders)),
            React.createElement("tbody", null, props.properyValueSets.map((pvs, index) => (React.createElement("tr", { key: index },
                React.createElement(row_selector_1.RowSelector, { rowIndex: index, screenAmountProfileFieldGroup: props.screenAmountProfileFieldGroup, selectedProperties: pvs, onChange: props.onChange, readOnlyProperties: props.readOnlyProperties, properties: createPropertyDefinitions(props.pressure, property_1.PropertyValueSet.getAmount("temperature", pvs), props.showPower) }),
                React.createElement("td", null,
                    React.createElement(Elements.StandardButton, { onClick: () => props.onDelete(index) }, "Delete"))))))));
    }));
}
function createPropertyDefinitions(pressure, temperature, showPower) {
    return showPower
        ? createPropertiesWithPower(pressure, temperature)
        : createPropertiesWithoutPower(pressure, temperature);
}
function createPropertiesWithoutPower(pressure, temperature) {
    return [
        {
            sort_no: 1,
            name: "temperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: "humidity",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [],
            conversionParameters: {
                pressure: pressure,
                temperature: temperature
            }
        },
        {
            sort_no: 1,
            name: "enthalpy",
            group: "",
            quantity: "SpecificEnthalpy",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function createPropertiesWithPower(pressure, temperature) {
    return [
        ...createPropertiesWithoutPower(pressure, temperature),
        {
            sort_no: 1,
            name: "sensiblepower",
            group: "",
            quantity: "Power",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: "totalpower",
            group: "",
            quantity: "Power",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=component.js.map